import EstruturaCadastro from '../../spa/estrutura-usuario/EstruturaCadastro';

export default {
  path: 'estrutura-usuario',
  name: 'estrutura-usuario',
  component: EstruturaCadastro,
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/config/router/estrutura-usuario.js